<!--
  Preparazione Ordine — page dettaglio + 4-step wizard (v2.11.0 J.3).
  Route: /prepare-order/:id (admin) e /warehouseorders/:id (display).

  Layout Diakonix native:
   - Sticky header con back + titolo + chip stato + cliente
   - 4 sezioni info (Date / Cliente / Indirizzo / Spedizione)
   - Status banner + progress bar nativi
   - 4-step wizard timeline (Raccolta prodotti → documenti → imballaggio → spedizione)
   - Action buttons (Indietro / Sincronizza / Inizia / Continua / Sospendi / Blocca|Sblocca / Completa)
   - Sub-modali wizard (J.4) condizionali a fine + popover-warning inline

  Drop (vs legacy):
   - kendo-progressbar (→ native progress)
   - ion-progress-bar (→ native progress)
   - <app-product-detail-modal>: dead include (isProdopen mai settato qui)
   - <app-test-dialog>: legacy hook generalBehaviour (era debug)
-->
@if (order) {
  <div class="prep-det-page">

    <!-- ============ HEADER ============ -->
    <header class="prep-det-header">
      <div class="title-block">
        <h1 class="page-title">
          📦 Preparazione Ordine
          <span class="order-num">{{ order.or_order_number }}</span>
        </h1>
        <p class="subtitle">
          <strong>{{ order.or_customer }}</strong>
          @if (order.or_partial === 'S') {
            <span class="chip chip--partial">Parziale</span>
          }
        </p>
      </div>

      <div class="header-status">
        <span class="status-chip" [class]="'status-chip--' + iconStatusClass()">
          <i class="bx bx-radio-circle-marked"></i>
          {{ order.icon?.label || '—' }}
        </span>
      </div>
    </header>

    <!-- ============ INFO ORDINE ============ -->
    <section class="info-grid">
      <div class="info-card">
        <h4>Data ordine</h4>
        <p>{{ order.date || '—' }}</p>
      </div>
      <div class="info-card">
        <h4>Consegna prevista</h4>
        <p>{{ order.expected_shipping_date || '—' }}</p>
      </div>
      <div class="info-card">
        <h4>N° Colli</h4>
        <p>{{ order.boxes?.length ?? 0 }}</p>
      </div>
      <div class="info-card">
        <h4>N° Pezzi</h4>
        <p>{{ order.vs_details?.op_articles_number ?? '—' }}</p>
      </div>
      <div class="info-card">
        <h4>Peso totale</h4>
        <p>{{ order.totalWeight || '—' }}</p>
      </div>
      <div class="info-card info-card--operator">
        <h4>Operatore</h4>
        <p>
          <span>{{ order.vs_details?.ac_last_name || '—' }}</span>
          <button
            type="button"
            class="btn-change-op"
            [title]="isBlocked()
              ? 'Cambia operatore'
              : 'Blocca prima l’ordine per cambiare operatore'"
            [disabled]="!isBlocked()"
            (click)="openChangeOperator()"
          >
            <i class="bx bx-transfer-alt"></i>
          </button>
        </p>
      </div>
    </section>

    <!-- ============ DESTINAZIONE ============ -->
    <section class="address-card">
      <h3 class="card-title"><i class="bx bx-map"></i> Destinazione</h3>
      <div class="address-grid">
        <div class="info-card info-card--span-2">
          <h4>Indirizzo</h4>
          <p>{{ order.or_shipping_address || '—' }}</p>
        </div>
        <div class="info-card">
          <h4>Città</h4>
          <p>{{ order.or_shipping_city || '—' }}</p>
        </div>
        <div class="info-card">
          <h4>CAP</h4>
          <p>{{ order.or_shipping_zip || '—' }}</p>
        </div>
        <div class="info-card">
          <h4>Provincia</h4>
          <p>{{ order.or_shipping_prov || '—' }}</p>
        </div>
        <div class="info-card">
          <h4>Nazione</h4>
          <p>{{ order.or_shipping_country || '—' }}</p>
        </div>
      </div>
    </section>

     <!-- ============ SPEDIZIONE ============ -->
    <section class="address-card">
      <h3 class="card-title"><i class="bx bx-car"></i> Spedizione</h3>
      <div class="address-grid">
        <div class="info-card">
          <h4>Corriere</h4>
          <p>
            {{
              order.vs_details?.carrier_desc
              || order.vs_details?.carrier_other
              || '—'
            }}
          </p>
        </div>
        <div class="info-card info-card--span-2">
          <h4>Riferimento</h4>
          <p>{{ order.or_note || '—' }}</p>
        </div>
      </div>
    </section>

    <!-- ============ STATUS + PROGRESS ============ -->
    <section class="progress-section">
      <div class="progress-wrap">
        <div
          class="progress-fill"
          [style.width.%]="order.status[0].tab_order_status_perc || 0"
        ></div>
        <span class="progress-label">
          {{ +(order.status[0].tab_order_status_perc || 0) | number:'1.0-1' }}%
        </span>
      </div>
    </section>

    <!-- ============ 4-STEP WIZARD ============ -->
    <section class="wizard">
      <h3 class="card-title"><i class="bx bx-list-check"></i> Workflow di preparazione</h3>
      <div class="wizard-steps">
        @for (step of steps; track step.index) {
          <div
            class="wizard-step"
            [class.wizard-step--done]="isStepDone(step.index)"
            [class.wizard-step--active]="isStepActive(step.index)"
            [class.wizard-step--pending]="isStepPending(step.index)"
          >
            <div class="step-circle">
              @if (isStepDone(step.index)) {
                <i class="bx bx-check"></i>
              } @else {
                <span>{{ step.index }}</span>
              }
            </div>
            <div class="step-content">
              <h4 class="step-title">{{ step.title }}</h4>
              <button
                type="button"
                class="step-btn"
                (mouseenter)="
                  (isSuspended() || isBlocked()) && step.index === 1
                    ? onHoverStart(order.order_id)
                    : null
                "
                (click)="
                  !isSuspended() && !isBlocked()
                    ? step.handler()
                    : null
                "
              >
                <i class="bx" [class]="step.icon"></i>
                {{ step.buttonText }}
              </button>
            </div>
          </div>
        }
      </div>
    </section>

    <!-- ============ ACTIONS ============ -->
    <footer class="actions">
      <button
        type="button"
        class="action-btn action-btn--neutral"
        (click)="back()"
      >
        <i class="bx bx-arrow-back"></i>
        Indietro
      </button>

      @if (!isDDT) {
        <button
          type="button"
          class="action-btn action-btn--info"
          (click)="synchronizeOrder()"
        >
          <i class="bx bx-sync"></i>
          Sincronizza
        </button>
      }

      <!--
        🚨 v2.11.1 (#4): tutti i bottoni status hanno ora [disabled] su
        `actionLoading` (lock globale durante in-flight) e icona spinning
        sul bottone correntemente in elaborazione. Senza questo, l'utente
        cliccava più volte / non capiva se il click avesse effetto.
      -->
      @if (isSuspended()) {
        <button
          type="button"
          class="action-btn action-btn--success"
          [disabled]="actionLoading !== null"
          (click)="start()"
        >
          @if (actionLoading === 'start') {
            <i class="bx bx-loader-alt bx-spin"></i>
          } @else {
            <i class="bx bx-play-circle"></i>
          }
          Continua
        </button>
      }

      @if (order.status[0].os_status_order_cod === 1) {
        <button
          type="button"
          class="action-btn action-btn--success"
          [disabled]="actionLoading !== null"
          (click)="start()"
        >
          @if (actionLoading === 'start') {
            <i class="bx bx-loader-alt bx-spin"></i>
          } @else {
            <i class="bx bx-run"></i>
          }
          Inizia
        </button>
      }

      @if (
        order.status[0].os_status_order_cod !== 1 &&
        order.status[0].os_status_order_cod !== 11 &&
        order.status[0].os_status_order_cod !== 100 &&
        order.status[0].os_status_order_cod !== 101
      ) {
        <button
          type="button"
          class="action-btn action-btn--suspend"
          [disabled]="actionLoading !== null"
          (click)="suspend()"
        >
          @if (actionLoading === 'suspend') {
            <i class="bx bx-loader-alt bx-spin"></i>
          } @else {
            <i class="bx bx-pause-circle"></i>
          }
          Sospendi
        </button>
      }

      @if (isBlocked()) {
        <button
          type="button"
          class="action-btn action-btn--unblock"
          [disabled]="actionLoading !== null"
          (click)="unblock()"
        >
          @if (actionLoading === 'unblock') {
            <i class="bx bx-loader-alt bx-spin"></i>
          } @else {
            <i class="bx bx-lock-open-alt"></i>
          }
          Sblocca
        </button>
      } @else if (
        order.status[0].os_status_order_cod !== 11 &&
        order.status[0].os_status_order_cod !== 101
      ) {
        <button
          type="button"
          class="action-btn action-btn--block"
          [disabled]="actionLoading !== null || order.status[0].os_status_order_cod === 7"
          (click)="block()"
        >
          @if (actionLoading === 'block') {
            <i class="bx bx-loader-alt bx-spin"></i>
          } @else {
            <i class="bx bx-lock-alt"></i>
          }
          Blocca
        </button>
      }

      @if (
        order.status[0].os_status_order_cod > 1 &&
        order.status[0].os_status_order_cod === 5 &&
        order.status[0].os_status_order_cod < 100
      ) {
        <button
          type="button"
          class="action-btn action-btn--primary"
          [disabled]="order.status[0].os_status_order_cod < 5"
          (click)="done()"
        >
          <i class="bx bx-badge-check"></i>
          Completa
        </button>
      }

      <!-- File input nascosto per firma cliente (link da J.4 confirm-shipment) -->
      <input
        #signatureInput
        type="file"
        accept="image/*"
        style="display:none"
        (change)="onFileLoad($event)"
      />
    </footer>
  </div>
}

<!-- ============ SUB-MODALI WIZARD (J.4) ============ -->
@if (closeServ.isCheckOn) {
  <app-confirm-products
    [opened]="closeServ.isCheckOn"
    [product_id]="checkProduct"
    (modalClosed1)="bigReload()"
  ></app-confirm-products>
}
@if (closeServ.isBoxCheck) {
  <app-confirm-boxes
    [opened]="closeServ.isBoxCheck"
    [product_id]="isCheckBox"
    (modalClosed1)="bigReload()"
  ></app-confirm-boxes>
}
@if (closeServ.isOpenedDoc) {
  <app-confirm-documents
    [opened]="closeServ.isOpenedDoc"
    [product_id]="checkDoc"
    (modalClosed1)="bigReload()"
  ></app-confirm-documents>
}
@if (closeServ.isShipOn) {
  <app-confirm-shipment
    [opened]="closeServ.isShipOn"
    [product_id]="checkShip"
    (modalClosed1)="bigReload()"
  ></app-confirm-shipment>
}

<!-- ============ POPOVER WARNING (sync) ============ -->
@if (openModal.isPopover && order) {
  <app-popover-warning
    [openedWarningMessage]="openModal.isPopover"
    (modalClosed1)="synchroneOrder(order.order_id, order.or_gamma_id)"
  ></app-popover-warning>
}
